/**
 * FctProveedor — raíz de una app React + Ant Design con el sistema de Sistemas FCT.
 *
 * Aplica el tema de la piel, el idioma español de Ant Design y de dayjs,
 * carga Roboto, Roboto Mono y Source Serif 4, e importa tokens.css y fct.css.
 *
 *   <FctProveedor piel="interna">
 *     <App />
 *   </FctProveedor>
 *
 * Para una vista compacta (listados) basta envolverla en
 * <ConfigProvider theme={fctTema('interna', 'compacta')}> y añadir la clase fct-compacta.
 */
import { useEffect, type ReactNode } from 'react';
import { ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import dayjs from 'dayjs';
import 'dayjs/locale/es';
import { fctTema, type FctPiel, type FctDensidad } from './theme';
import { fct } from '../tokens/tokens';
import '../tokens/tokens.css';
import '../css/fct.css';
import './fct-antd.css';

dayjs.locale('es');

const ID_FUENTES = 'fct-fuentes';

export interface FctProveedorProps {
  piel?: FctPiel;
  densidad?: FctDensidad;
  children: ReactNode;
}

export function FctProveedor({ piel = 'interna', densidad = 'comoda', children }: FctProveedorProps) {
  useEffect(() => {
    if (typeof document === 'undefined' || document.getElementById(ID_FUENTES)) return;
    const link = document.createElement('link');
    link.id = ID_FUENTES;
    link.rel = 'stylesheet';
    link.href = fct.googleFonts;
    document.head.appendChild(link);
  }, []);

  return (
    <ConfigProvider theme={fctTema(piel, densidad)} locale={esES}>
      <div data-fct-piel={piel} className={densidad === 'compacta' ? 'fct-compacta' : undefined} style={{ minHeight: '100%' }}>
        {children}
      </div>
    </ConfigProvider>
  );
}
